// types/index.ts - Централізований експорт типів

import { UserRole } from './entities';
import type { IUser, IProperty, PaymentStatus } from './entities';

export * from './entities';
export * from './properties';
export * from './units';
export * from './leases';
// export * from './payments'; // Тимчасово відключено через конфлікт PaymentStatus
export * from './api-types'; // Новий експорт API типів

// Селективний експорт з payments.ts щоб уникнути конфлікту
export type {
  PaymentType,
  PaymentMethod as PaymentMethodApi,
  PaymentStatus as PaymentStatusApi,
  CreatePaymentRequest,
  PaymentResponse,
  PaymentListResponse,
  PaymentStatisticsData,
  PeriodStatisticsData,
  PaymentTransaction,
  Debtor,
} from './payments';

export const isDev = process.env.NODE_ENV === 'development';

export type ProfileState = {
  profile: IUser | null;
  loading: boolean;
  error: null | string;
  serverErrors: { [key: string]: string[] } | null;
};

export type SignupDto = {
  // Базові поля
  firstname: string;
  lastname: string;
  email: string;
  password: string;
  role: UserRole;

  // Manager поля
  companyName?: string;
  department?: string;
  jobTitle?: string;

  // Додаткові поля
  province?: string;
  phone?: string;
  ageGroup?: string;

  // Для tenant
  inviteToken?: string | null;
};

export type SigninDto = {
  email: string;
  password: string;
  inviteToken?: string | null;
};

export interface AuthResponse {
  accessToken: string;
  refreshToken: string;
  user: IUser;
  unitId?: number;
}

export interface ILogoutResponse {
  message: string;
}

export type AuthErrorsResponse = {
  message: string;
  errors?: {
    [key: string]: string[];
  };
  error: string;
  statusCode: number;
};

export interface SocketResponse<T, E = string> {
  data: T;
  error?: E;
}

export interface WsException {
  status?: 'error' | 'exception';
  message: string;
  name?: string;
}

//  типы для прав доступа
export type Permission =
  | 'view_dashboard'
  | 'manage_properties'
  | 'manage_tenants'
  | 'manage_managers'
  | 'view_financial_reports'
  | 'manage_payments'
  | 'view_own_data'
  | 'communicate'
  | 'order_services';

// Права доступа по ролям
export const ROLE_PERMISSIONS: Record<UserRole, Permission[]> = {
  [UserRole.OWNER]: [
    'view_dashboard',
    'manage_properties',
    'manage_tenants',
    'manage_managers',
    'view_financial_reports',
    'manage_payments',
  ],
  [UserRole.MANAGER]: [
    'view_dashboard',
    'manage_properties',
    'manage_tenants',
    'manage_payments',
  ],
  [UserRole.TENANT]: [
    'view_own_data',
    'communicate',
    'order_services',
    'manage_payments',
  ],
};